
import Container from '@mui/material/Container';
import CustomContainer from '../components/CustomContainer';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import Typography from '@mui/material/Typography';
import { useRef, useContext } from "react"
import DashboardContext from '../context/DashboardContext';
import { useEffect } from 'react';
import { saveAs } from 'file-saver';
export function Movimento() {
  const { clientLogo, movementUrl , panelTitle } = useContext(DashboardContext);

  const canvasRef = useRef();

  useEffect(() => {
    const movimento = new Image();
    const LOGO = new Image();
    movimento.src = movementUrl;
    LOGO.src = clientLogo;
    movimento.setAttribute('crossOrigin', 'anonymous');
    LOGO.setAttribute('crossOrigin', 'anonymous');
    const canvas = canvasRef.current.getContext('2d');
    movimento.onload = async function () {
      await canvas.drawImage(movimento, 0, 0, 1080, 1080);
      await canvas.drawImage(LOGO, 705, 835, 332, 208);
      const dataURL = canvasRef.current.toDataURL("image/png");
      const pngName = 'movimento_' + panelTitle;
      saveAs(dataURL, pngName);
    }
  }, [])
  return (
    <Container>
      <CustomContainer
        style={{ padding: "32px 48px" }}
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          minWidth: 1100,
        }}
      >

        { /* TÍTULO DA PÁGINA */}
        {/* <Typography
            color="primary"
            component="h2"
            mb={4}
            sx={{
              alignItems: "center",
              display: "flex",
              justifyContent: "center",
            }}
            variant="h4"
          >
            <QrCode2Icon fontSize="md" sx={{ mr: 1 }} />
            Movimento
          </Typography> */}
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <canvas ref={canvasRef} id="canvas" width="1080" height="1080" >
          </canvas>
        </div>
      </CustomContainer>
    </Container>
  )
}